export default "__VITE_ASSET__1d15c709__"